import {
  HOT_LIST,
  INITIAL_VALUES,
  KEYS,
  PROJECTS_SCOPE,
} from "utils/constants";

export const setPaginationHistory = ({ footprint, value, take, count }) => {
  const skip = (value - 1) * take;
  localStorage.setItem(
    KEYS.PAGINATION,
    JSON.stringify({
      ...JSON.parse(localStorage.getItem(KEYS.PAGINATION) || "{}"),
      [footprint]: { value, skip: skip < count ? skip : 0, take, count },
    }),
  );
};

export const getPaginationHistory = (footprint) => {
  const paginationHistory = JSON.parse(
    localStorage.getItem(KEYS.PAGINATION) || "{}",
  );
  return paginationHistory[footprint] || {};
};

export const clearPaginationHistory = (footprint) => {
  localStorage.setItem(
    KEYS.PAGINATION,
    JSON.stringify({
      ...JSON.parse(localStorage.getItem(KEYS.PAGINATION) || "{}"),
      [footprint]: undefined,
    }),
  );
};

export const decreasePagination = (footprint) => {
  const pagination = getPaginationHistory(footprint);
  setPaginationHistory({
    footprint,
    ...pagination,
    count: (pagination.count -= 1),
  });
};

export const getProjectsListPaginationFootprint = (
  scope = PROJECTS_SCOPE.MINE,
  hotMode = false,
) => `projectsList:${scope}${hotMode ? ":hot" : ""}`;

export const getProjectsListPaginationHistory = (
  scope = PROJECTS_SCOPE.MINE,
  hotMode = false,
) => {
  const scopedHistory = getPaginationHistory(
    getProjectsListPaginationFootprint(scope, hotMode),
  );
  let history = scopedHistory;
  if (
    Object.keys(scopedHistory).length === 0 &&
    scope === PROJECTS_SCOPE.MINE &&
    !hotMode
  ) {
    history = getPaginationHistory("projectsList");
  }
  const take = Number(history.take) || INITIAL_VALUES.take;
  return {
    skip: INITIAL_VALUES.skip,
    ...history,
    take: hotMode ? Math.max(take, HOT_LIST.PAGE_SIZE) : take,
  };
};
